import { render, staticRenderFns } from "./ForecastResearch.vue?vue&type=template&id=232c388d&scoped=true&"
import script from "./ForecastResearch.vue?vue&type=script&lang=js&"
export * from "./ForecastResearch.vue?vue&type=script&lang=js&"
import style0 from "./ForecastResearch.vue?vue&type=style&index=0&id=232c388d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c388d",
  null
  
)

export default component.exports